/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum APIShippingStatusEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5
}


export function instanceOfAPIShippingStatusEnum(value: any): boolean {
    for (const key in APIShippingStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(APIShippingStatusEnum, key)) {
            if (APIShippingStatusEnum[key as keyof typeof APIShippingStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function APIShippingStatusEnumFromJSON(json: any): APIShippingStatusEnum {
    return APIShippingStatusEnumFromJSONTyped(json, false);
}

export function APIShippingStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIShippingStatusEnum {
    return json as APIShippingStatusEnum;
}

export function APIShippingStatusEnumToJSON(value?: APIShippingStatusEnum | null): any {
    return value as any;
}

